var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"app"}},[(!_vm.isAppLoaded)?_c('div',{staticClass:"spinner-placeholder"},[_c('img',{attrs:{"src":"/img/loading.png"}})]):_vm._e(),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }